import React, { useEffect, useRef, useState } from "react";
import { Button, ButtonToolbar, FormInstance, Message, toaster } from "rsuite";
import { useTranslation } from "react-i18next";
import { IEmailDetails } from "store/customers/customer-details/customer-details-types";
import ModalContainer from "components/Common/Modal/ModalContainer";
import EmailAddressesBox from "components/Common/EmailAddressesBox/EmailAddressesBox";
import constants from "utils/constants";
import css from "./SendEmail.module.css";

interface ComponentProps {
    envMoniker: string;
    isOpened: boolean;
    userId: string;
    isEmailSent: boolean;
    setIsOpened: (isOpened: boolean) => void;
    sendEmailWithLink: (
        envMoniker: string,
        emailDetails: IEmailDetails
    ) => void;
    setEmailSent: (isEmailSent: boolean) => void;
}
const SendEmail: React.FC<ComponentProps> = ({
    envMoniker,
    isOpened,
    userId,
    isEmailSent,
    setIsOpened,
    sendEmailWithLink,
    setEmailSent,
}: ComponentProps) => {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance<Record<string, any>> | null>(null);
    const [emailAddress, setEmailAddress] = useState("");
    const [resultEmailAdresses, setResultEmailAdresses] = useState<string[]>(
        []
    );
    const isResultArray = resultEmailAdresses.length > 0;

    useEffect(() => {
        if (isEmailSent) {
            toaster.push(
                <Message showIcon type="success" closable>
                    {t("sendEmail.successMessage")}
                </Message>,
                {
                    duration: constants.alertDurationMsec,
                }
            );
            setEmailSent(false);
        }
    });

    const onModalCloseHandler = () => {
        setIsOpened(false);
        setEmailAddress("");
        setResultEmailAdresses([]);
    };

    const onSubmitHandler = () => {
        if (!formRef.current?.check()) {
            return;
        }
        if (isResultArray || emailAddress) {
            if (emailAddress) {
                resultEmailAdresses.push(emailAddress);
            }
            const sendObject = {
                userId: userId,
                receivers: resultEmailAdresses,
            };
            sendEmailWithLink(envMoniker, sendObject);
            onModalCloseHandler();
        }
    };

    const header = <h1>{t("sendEmail.title")}</h1>;
    const footer = (
        <ButtonToolbar>
            <Button
                type="submit"
                appearance="primary"
                disabled={!isResultArray && !emailAddress}
                className={css.saveButton}
                onClick={onSubmitHandler}
            >
                {t("sendEmail.sendButton")}
            </Button>
        </ButtonToolbar>
    );

    return (
        <ModalContainer
            open={isOpened}
            onClose={onModalCloseHandler}
            header={header}
            footer={footer}
        >
            <p>{t("sendEmail.info")}</p>
            <EmailAddressesBox
                formRef={formRef}
                emailAddress={emailAddress}
                resultEmailAddresses={resultEmailAdresses}
                isResultArray={isResultArray}
                boxLabel={t("sendEmail.emailAddressLabel")}
                tooltipText={null}
                setEmailAddress={setEmailAddress}
                setResultEmailAddresses={setResultEmailAdresses}
            />
        </ModalContainer>
    );
};

export default SendEmail;
